import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider, Modal, ModalProps } from 'antd';
import React, { useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';

import { RightProvider } from '@/components/RightProvider';
import { useTranslate } from '@/hooks/useTranslate';
import en from '@/lang/en.json';
import zh from '@/lang/zh.json';
import theme from '@/theme';

interface TFunc {
  (key: string, values?: Record<string, any>): string;
}

interface CreateContent {
  (onClose: () => void, contentRef: React.RefObject<any>, t: TFunc): JSX.Element;
}
interface ModalPropsType {
  antdModalProps: ModalProps | ((t: TFunc) => ModalProps);
  renderContent: CreateContent;
  handler?: any;
}

const ProxyModal: React.FC<{
  antdModalProps: ModalProps | ((t: TFunc) => ModalProps);
  renderContent: CreateContent;
  destoryHandel: () => void;
}> = (props) => {
  const { antdModalProps, renderContent, destoryHandel } = props;
  const contentRef = useRef<any>(null);
  const { t } = useTranslate();
  const translateAntdModalProps =
    typeof antdModalProps === 'function' ? antdModalProps(t) : antdModalProps;
  const [visible, setVisible] = useState(translateAntdModalProps.open);
  const close = () => {
    setVisible(false);
    setTimeout(() => {
      destoryHandel();
    }, 600);
  };

  const config: ModalProps = {
    ...translateAntdModalProps,
    open: visible,
    onCancel: close,
    footer: null,
  };

  return <Modal {...config}>{renderContent(close, contentRef, t)}</Modal>;
};

export const imperativeModal = {
  show: (config: ModalPropsType) => {
    const { antdModalProps, renderContent } = config;
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);
    const destoryHandel = () => {
      root.unmount();
      // ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    };
    const modal = (
      <ProxyModal
        antdModalProps={antdModalProps}
        renderContent={renderContent}
        destoryHandel={destoryHandel}
      />
    );
    const lang = navigator.language.startsWith('zh') ? 'zh' : 'en';
    root.render(
      <RightProvider>
        <IntlProvider locale={lang} messages={lang === 'en' ? en : zh}>
          <ConfigProvider theme={theme}>
            <StyleProvider hashPriority="high">{modal}</StyleProvider>
          </ConfigProvider>
        </IntlProvider>
      </RightProvider>,
    );
    return destoryHandel;
  },
};
